import { gql } from '@apollo/client'

export const GET_ARTISTS_BY_NAME = gql`
  query ($name: String!) {
    getArtistsByName(name: $name) {
      id
      name
      label_id
      facebook_id
      opus_id
      gps_status
      spotify_id
      gcdm_info {
        company
        country
        genre
      }
    }
  }
`
